"use client";
import React, { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { useSearchParams } from "next/navigation";
import PageLayout from "@/layouts/pageLayout";
import { scrollToElement } from "@/utils/scrollToElement";
import Hero from "./components/hero";
import PoliciesComponent from "./components/policies";

const PoliciesPage = () => {
  const params = useSearchParams();
  useEffect(() => {
    const policy = params.get("policy");
    if (policy) {
      scrollToElement(policy, 120);
    }
  }, [params]);

  return (
    <Box>
      <Hero />
      <PageLayout showContactForm>
        <PoliciesComponent />
      </PageLayout>
    </Box>
  );
};

export default PoliciesPage;
